<div class="alert {{ type ? 'alert-' + type : '' }} mb-2" [style]="style">
  <div *ngIf="customIcon || type" style="width: 25px; margin-right: 0.75rem">
    <svg [class]="'unity-icon unity-icon-xl ' + customIcon || getAlertIcon()" [class.hide]="noIcon">
      <use attr.xlink:href="#{{ customIcon ? customIcon : getAlertIcon() }}"></use>
    </svg>
  </div>
  <ng-content></ng-content>
</div>
